// extracted by mini-css-extract-plugin
export default {"inputBox":"Input_inputBox__q2bfd","icon":"Input_icon__nxNs+"};